import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
  Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogFooter,
} from "@/components/ui/dialog";
import HospitalPicker from "@/components/HospitalPicker";

/**
 * Modal that edits the map's metadata (hospital / center / date).
 * Cascading updates to the linked raw map and cases happen on the backend
 * via PATCH /api/filtered-maps/{fid}.
 */
export default function MetaEditDialog({ value, onChange, onClose, onSave, loading }) {
  return (
    <Dialog open={!!value} onOpenChange={(v) => !v && onClose()}>
      <DialogContent data-testid="dialog-edit-meta">
        <DialogHeader>
          <DialogTitle>Editar dados do mapa</DialogTitle>
          <DialogDescription>
            Hospital, centro cirúrgico e data. As alterações são propagadas para
            o mapa bruto e para os casos cirúrgicos vinculados.
          </DialogDescription>
        </DialogHeader>
        {value && (
          <div className="space-y-4 py-2">
            <div className="space-y-1.5">
              <Label>Data do mapa</Label>
              <Input type="date" value={value.map_date || ""}
                onChange={(e) => onChange({ ...value, map_date: e.target.value })}
                data-testid="edit-meta-date" />
            </div>
            <div className="space-y-1.5">
              <Label>Hospital</Label>
              <HospitalPicker value={value} testid="edit-meta-hospital"
                onChange={(h) => onChange({ ...value, ...h })} />
            </div>
            <div className="space-y-1.5">
              <Label>Centro Cirúrgico</Label>
              <Input value={value.center || ""}
                onChange={(e) => onChange({ ...value, center: e.target.value })}
                placeholder="Centro Cirúrgico II"
                data-testid="edit-meta-center" />
            </div>
          </div>
        )}
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>Cancelar</Button>
          <Button onClick={onSave} disabled={loading}
            className="bg-blue-700 hover:bg-blue-800" data-testid="btn-save-meta">
            {loading ? "Salvando..." : "Salvar"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
